export default {
	cinema: {
		address: 'ул. Смоленская, 60',
		place: null,
		phoneNumbers: ['+7(48166)410-30', '+7(48166)412-87'],
		facebook: null,
		instagram: null,
		vk: 'https://vk.com/duhkinozarya',
		twitter: null,
		odnoklassniki: null,
		youtube: null,
		app: {
			appstore: null,
			googleplay: 'https://play.google.com/store/apps/details?id=ru.kinoplan.cinema.zarya',
		},
		payment: {
			active: true,
			card: ['mir', 'visa', 'mastercard', 'maestro', 'sbp', 'sberpay'],
		},
		maps: 'https://yandex.ru/maps/-/CBBGqJBVGC',
		selectButton: {
			options: [],
			selectedOptionValue: null,
		},
		soonPageIsEnabled: false,
		saleRules: false,
		details: false,
	},
	feedback: true,
};
